import { useMutation } from "@apollo/client";
import { REMOVE_MAILBOX } from "../mailbox.queries";
import {
  RemoveMailboxMutation,
  RemoveMailboxMutationVariables,
} from "../../../__generated__/RemoveMailboxMutation";

export const useRemoveMailbox = () => {
  return useMutation<RemoveMailboxMutation, RemoveMailboxMutationVariables>(
    REMOVE_MAILBOX,
    {
      refetchQueries: "active",
    }
  );
};
